import { FC, PropsWithChildren } from 'react';

import { StackProps, Stack, Toolbar } from '@mui/material';

type MainProps = PropsWithChildren &
  StackProps & {
    isMini: boolean;
  };

const Main: FC<MainProps> = (prop) => {
  const { children, isMini, sx, ...others } = prop;

  return (
    <Stack
      component="main"
      direction="column"
      sx={{
        flexGrow: 1,
        p: { xs: '16px', sm: '24px' },
        backgroundColor: 'custom.background',
      }}
      {...others}
    >
      <Toolbar sx={{ height: { xs: 63, sm: 71 } }} />
      {children}
    </Stack>
  );
};

export default Main;
